import React, { useState, useEffect } from 'react';
import { PageRestricted } from 'pages/errors/page-restricted';
import { UserAccess } from 'components/user-access';
import { LicenceCheckingService, EmployeeService } from 'services';
import { NotificationToaster } from 'components/notifications';
import { Intent } from '@blueprintjs/core';
import { Breadcrumbs } from 'components/navigation';
import { LicenceCheckingPolicyWizard } from "pages/licence-checking/policies/shared"
import axios from 'axios';

export function LicenceCheckingPolicyCreate(props) {

    const requiredAction = "LicenceChecking:Manage";
    const [loading, setLoading] = useState(true);

    const [employeeOptions, setEmployeeOptions] = useState({});
    const [licenceCheckingOptions, setLicenceCheckingOptions] = useState({});
    const [credits, setCredits] = useState(0);
    
    const policy =
    {
        policyName: "",
        startDate: "",
        employeeCategories: [],
        employeeTypes: [],
        employeeStatuses: [],
        checkFrequency: 1,
        checkFrequencyType: "",
        licenceCheckingPolicyRule: [],
        advancedRules: [],
        filterByLocations: false,
        employeeLocations: []
    };

    useEffect(() => {
        axios.all([EmployeeService.getEmployeeOptions(), LicenceCheckingService.getLicenceCheckingOptions(), LicenceCheckingService.getCredits()]).then(axios.spread(function (getEmployeeOptionsResponse, getLicenceCheckingOptionsResponse, getCreditsResponse) {
            getEmployeeOptionsResponse.employeeStatuses = getEmployeeOptionsResponse.employeeStatuses.filter(c => c.name.toLowerCase() !== "inactive");
            getLicenceCheckingOptionsResponse.policyRules = getLicenceCheckingOptionsResponse.policyRules.filter(c => c.key.toLowerCase() !== "base");
            setEmployeeOptions(getEmployeeOptionsResponse);
            setLicenceCheckingOptions(getLicenceCheckingOptionsResponse);
            setCredits(getCreditsResponse.licenceCredits);
        })).catch(() => {
            NotificationToaster.show(Intent.DANGER, "Failed to get policy data. Please refresh the page.");
        }).finally(() => {
            setLoading(false);
        });

    }, []);

    return (

        <UserAccess perform={requiredAction}
            yes={() => (
                <>
                    <div className="row">
                    <Breadcrumbs items={props.breadcrumbs} />
                        <h1>New Licence Checking Policy</h1>

                        <LicenceCheckingPolicyWizard
                            loading={loading}
                            policy={policy}
                            employeeOptions={employeeOptions}
                            licenceCheckingOptions={licenceCheckingOptions}
                            credits={credits}
                            createPolicy
                        />
                    </div>
                </>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}